export default function Section2() {
  return (
    <div className="w-full Section2">
      <div className="flex flex-wrap items-center justify-center w-full section2-container">
        <div className="w-[80%] md:w-[80%] text-center">
          <h1 className="text-[24px] leading-[32px] md:text-[34px] font-bold mt-[40px] md:leading-[40px] pb-[1%]">
            Magento Development Services
          </h1>
          <p className="leading-[20px] text-[#373737] text-base font-open pb-[1%]">
            Mean3 offers Magento eCommerce development services. We help businesses build online stores that are secure, fast, and easy to use. We manage all aspects of Magento. This includes Magento web design, web development, and complete store development and support. We’re a trusted Magento development company. We create reliable and personalized solutions for businesses
            . Our team delivers effective Magento eCommerce web development. We aim to improve speed, enhance user experience, and boost sales.
          </p>
          <p className="leading-[20px] text-base text-[#DA2128] font-[400] font-open mb-[2%] mt-[-1%]">
            UI/UX Design | API Integration | PWA Implementation | Magento
            Development | Magento Maintenance | Security & Compliance
          </p>
        </div>
        <div className="line mx-auto my-[55px] md:mt-[4%] md:mb-0  w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]" ></div>
      </div>
    </div>
  );
}
